<template>
	<div class="sms-pay-view">
		<BaseAccordionCard :accordion_header="getStateWithParam('parking_rates_label')">
			<template v-slot:component>
				<ParkingInfo />
			</template>
		</BaseAccordionCard>

		<BaseAccordionCard :accordion_header="getStateWithParam('label_payparking_sms')">
			<template v-slot:component>
				<PayWithSmsCard />
			</template>
		</BaseAccordionCard>
	</div>
</template>

<script>
import ParkingInfo from "@/components/cards/ParkingInfoCard.vue";
import PayWithSmsCard from "@/components/cards/PayWithSmsCard.vue";

export default {
	name: "PayWithSms",
	components: {
		PayWithSmsCard,
		ParkingInfo
	},
	data() {
		return {};
	},
	mounted() {
		this.$nextTick(function () {
			this.$store.state.active_loader = false;
		})
	},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		}
	}
};
</script>

<style lang="scss" scoped>
</style>




